import { Badge } from '@/components/ui/badge'
import { TaskStatus } from '@/types/entities'
import { getTaskStatusLabel, getTaskStatusVariant } from '../hooks/useTasks'
import { Loader2, CheckCircle, XCircle, Clock, Ban } from 'lucide-react'

interface TaskStatusBadgeProps {
  status: TaskStatus
}

export function TaskStatusBadge({ status }: TaskStatusBadgeProps) {
  const variant = getTaskStatusVariant(status)
  const label = getTaskStatusLabel(status)

  const Icon = () => {
    switch (status) {
      case 'RUNNING':
        return <Loader2 className="h-3 w-3 animate-spin mr-1" />
      case 'COMPLETED':
        return <CheckCircle className="h-3 w-3 mr-1" />
      case 'FAILED':
        return <XCircle className="h-3 w-3 mr-1" />
      case 'PENDING':
        return <Clock className="h-3 w-3 mr-1" />
      case 'CANCELLED':
        return <Ban className="h-3 w-3 mr-1" />
      default:
        return null
    }
  }

  return (
    <Badge variant={variant} className="flex items-center w-fit">
      <Icon />
      {label}
    </Badge>
  )
}
